import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';
import { Box } from '@qga/roo-ui/components';

const FormActions = styled(Box)`
  background: white;
  padding: ${themeGet('space.6')} ${themeGet('space.4')} ${themeGet('space.4')};
  box-shadow: 0px -2px 4px 0px #e6e6e6;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  ${themeGet('mediaQueries.0')} {
    padding: 0 ${themeGet('space.4')};
    box-shadow: none;
    position: inherit;
  }
`;

export default FormActions;
